import { GetHistoryRequestDto, GetHistoryResponseDto } from '@sparling/financial-common'
import axios, { AxiosRequestConfig } from 'axios'
import isNil from 'lodash/isNil'

export const fetchHistoryData = async (
  { token, ...params }: GetHistoryRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<GetHistoryResponseDto> => {
  const response = await axios.get(`${process.env.REACT_APP_REST_API_URL}/history`, {
    ...options,
    params: Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value) && value !== '')),
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

  return response.data
}
